<template>
    <div>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="item" v-for="(item, index) in list">
            <h2>{{item.id}}: </h2>
            <p class="questContainer">{{item.info}}</p>
        </div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Docinfo',
    components: {answerHeader},
    data(){
        return {
            id: this.$route.query.id,
            list:[]
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this._fetchDoc();
    },
    methods: {
        _fetchDoc(){
            Utils.$ajax({
                url: '/core/knowledge',
                data: {id: this.id}
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                if(!res.data || res.data.length == 0){
                    this.$toast('Content မလုံေလာက္ေတာ့ပါ');
                    return;
                }
                this.list = res.data;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .item{
        color: #fff;
        border-bottom: 1px dashed #fff;
        padding: rem(50) 0;
        h2{
            font-size: rem(32);
            margin-bottom: rem(30);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Docinfo.vue